export const TIMEZONE_LOCAL_KEY = 'bonsaiBeamTimezone';
export const RELATIVE_DATES_LOCAL_KEY = 'bonsaiBeamRelativeDates';
